import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { stateful, useObservable, useState } from '@adornis/functional-lit/stateful.js';
import { filterBadge } from '@ils/filter-badges/client/filter-badge.js';
import { nothing } from 'lit';

export const filterBadgeBar = stateful(
  ({
    selectables,
    renderString,
    onSelect,
    selected: initialSelected,
  }: {
    selectables: any[];
    renderString: (value: any) => string;
    onSelect: (value: any) => void;
    selected: any;
  }) => {
    const design = useObservable(() => DesignSystem.currentTheme, []);
    const [selected, setSelected] = useState(initialSelected, [initialSelected]);
    if (!design) return nothing;
    return selectables.map(s =>
      filterBadge({
        selected: selected === s,
        title: renderString(s),
        onClick: () => {
          setSelected(s);
          onSelect(s);
        },
      }),
    );
  },
);
